<app-modal-basic modalContentId="impressaoProduto" #modal (closed)="handleOnClose()">

  <div class="app-modal-header">
    <h4 class="modal-title">
      <i class="modal-title icofont icofont-file-alt m-r-5"></i>
      Relatório de Produtos
    </h4>
    <button type="button" class="close basic-close" (click)="handleOnCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="app-modal-body">

    <div class="row">
      <div class="col-sm-12">
        <span>Selecione as colunas que deseja exibir na impressão.</span>
      </div>
    </div>

    <form [formGroup]="form">
        <div formGroupName="colunas">
            <app-dim-checkbox-list
            [formLabels]="labels"
            [minimoSelecionado]="1"
            mensagemErro="Nenhuma coluna marcada, relatório não pode ser gerado."
            (change)="onTabelaPrecoChange()">
            </app-dim-checkbox-list>
        </div>

        <div class="row mt-3" *ngIf="form.get('colunas.tabelaPreco')?.value">
            <div class="col-sm-12">
            <label class="label-required">Tabela de Preços</label>
            <ng-select
                [items]="tabelasPreco"
                placeholder="Selecione a Tabela de Preço"
                bindLabel="nome"
                bindValue="id"
                appendTo="#impressaoProduto"
                formControlName="tabelaPrecoId">
            </ng-select>
            <small class="text-danger" *ngIf="form.get('tabelaPrecoId')?.touched && form.get('tabelaPrecoId')?.errors?.required">
                A tabela de preço é obrigatória quando a coluna "Tabela de Preços" está marcada.
            </small>
            </div>
        </div>
    </form>

    <div class="row mt-3">
      <div class="col-12">
        <button
          class="btn btn-primary"
          [disabled]="form.invalid"
          (click)="handleOnPrint()"
        >
          <i class="icofont icofont-print"></i> Imprimir
        </button>

        <button class="btn btn-danger" (click)="handleOnCancel()">
          Cancelar
        </button>
      </div>
    </div>

  </div>

</app-modal-basic>